/**
 * Applies a theme scope to an element WITHOUT a reactive :class binding.
 *
 * Vue patches a changed :class by overwriting the element's className
 * wholesale, which wipes classes added at runtime by non-Vue code. On an
 * <ion-page> root that includes the router outlet's `ion-page-hidden` — so
 * flipping the Courses theme rewrote the class attribute of every CACHED
 * Courses page at once and un-hid them: the part chooser appeared over the
 * program landing without any navigation, and tapping its card then "hung"
 * because the router was already on that route.
 *
 * classList.add / classList.toggle are additive, so Ionic's classes survive.
 *
 * Use this on ANY element Ionic owns — an ion-page / master-layout root, and
 * every <ion-modal>. A dormant ion-modal is kept out of the way by Ionic's own
 * runtime class `overlay-hidden` (the thing making it `display: none`), so a
 * reactive class binding there un-hid every dormant Courses modal on the first
 * theme flip: each became a full-bleed overlay at z-index 20000+, and the page
 * behind them repainted correctly and then answered no touch at all. This file
 * used to say modals could keep the binding. They cannot.
 *
 * `:class="themeClass"` is still right for a plain div YOU render and nothing
 * else writes to — the notes-hub overlays, CourseCompleteModal and friends.
 *
 * Usage:
 *   <master-layout v-theme-scope="{ base: 'courses-theme', dark: 'courses-dark', isDark }">
 */
function apply(el, value) {
  const { base, dark, isDark } = value || {};
  if (base) el.classList.add(...base.split(' '));
  if (dark) el.classList.toggle(dark, !!isDark);
}

export default {
  mounted(el, binding) {
    apply(el, binding.value);
  },
  updated(el, binding) {
    apply(el, binding.value);
  },
};
